var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VCheckbox',_vm._g(_vm._b({attrs:{"input-value":_vm.value},on:{"change":_vm.change}},'VCheckbox',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }